import React from 'react';
import { FeaturePageLayout } from '../components/FeaturePageLayout';
import { Search, BarChart, Target, AlertCircle } from 'lucide-react';
import { MrAvatar } from '../components/MrAvatar';
export function BusinessDeepDive() {
  return <FeaturePageLayout customContent={<div className="flex justify-center -mt-8 mb-16 relative z-10" data-id="element-1373">
          <MrAvatar size={240} expression="thinking" data-id="element-1374" />
        </div>} hero={{
    badge: 'Step 2 of 7',
    h1: <>
            Business{' '}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-teal to-purple" data-id="element-1375">
              Deep Dive
            </span>
          </>,
    subtitle: 'We conduct a comprehensive analysis of your entire operation to identify exactly where AI can drive the most impact.'
  }} problem={{
    subtitle: 'The Analysis Gap',
    cards: [{
      icon: <Search className="w-6 h-6 text-teal" data-id="element-1376" />,
      title: 'Hidden Inefficiencies',
      desc: 'Most businesses have operational bottlenecks they cannot see because they are too close to the daily grind.'
    }, {
      icon: <AlertCircle className="w-6 h-6 text-purple" data-id="element-1377" />,
      title: 'Undefined Roles',
      desc: 'Staff roles often overlap or lack clear boundaries, making it hard to know what to automate.'
    }, {
      icon: <BarChart className="w-6 h-6 text-blue-400" data-id="element-1378" />,
      title: 'Unclear Metrics',
      desc: 'Without a deep dive, it is impossible to measure the true ROI of implementing AI solutions.'
    }]
  }} solution={{
    badge: 'The Process',
    title: 'Comprehensive Operational Audit',
    desc: 'We leave no stone unturned. Our deep dive covers every aspect of your business to build the perfect automation blueprint.',
    features: [{
      icon: <Target className="w-6 h-6 text-teal" data-id="element-1379" />,
      title: 'Services & Marketing',
      desc: 'We analyze your core offerings and how you take them to market.'
    }, {
      icon: <Search className="w-6 h-6 text-purple" data-id="element-1380" />,
      title: 'Staff & Competitors',
      desc: 'We map out your current team needs and analyze your competitive landscape.'
    }]
  }} data-id="element-1372" />;
}